/**
 * Modal Module - Controls modal open/close transitions for appointments
 */
export function initModal() {
  const modalBackdrop = document.querySelector('#appointment-modal');
  const openButtons = document.querySelectorAll('[data-open-modal]');
  const closeButtons = document.querySelectorAll('[data-close-modal]');

  if (!modalBackdrop) return;

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modalBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      modalBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  modalBackdrop.addEventListener('click', (e) => {
    if (e.target === modalBackdrop) {
      modalBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
}
